/* SP HYDRATION PLANNER — 100PLUS partner tool.
   Live Singapore heat stress (NEA WBGT via data.gov.sg) + activity + body → a
   before / during / after plan mapped to 100PLUS SKUs. Mounted by
   sections/sp-hydration-planner.liquid (JSON config island per root).

   The rules below are GENERAL GUIDANCE (ACSM-style ranges), not medical advice.
   All thresholds live in RULES so 100PLUS's nutrition team can tune them. */
(function () {
  'use strict';

  var API = 'https://api-open.data.gov.sg/v2/real-time/api/';
  var CACHE_MIN = 10;

  /* ---------- activities (sweat L/h for a 70 kg adult at moderate effort, ~26°C WBGT) ---------- */
  var ACT = {
    run:        { label: 'Running',            icon: 'run',     rate: 1.0,  kind: 'sport',     outdoor: true },
    football:   { label: 'Football',           icon: 'ball',    rate: 1.0,  kind: 'sport',     outdoor: true },
    basketball: { label: 'Basketball',         icon: 'hoop',    rate: 0.9,  kind: 'sport',     outdoor: true },
    badminton:  { label: 'Badminton',          icon: 'shuttle', rate: 0.8,  kind: 'sport',     outdoor: false },
    tennis:     { label: 'Tennis',             icon: 'tennis',  rate: 0.9,  kind: 'sport',     outdoor: true },
    cycling:    { label: 'Cycling',            icon: 'bike',    rate: 0.8,  kind: 'sport',     outdoor: true },
    tri:        { label: 'Triathlon / endurance', icon: 'tri',  rate: 1.0,  kind: 'endurance', outdoor: true },
    gym:        { label: 'Gym & strength',     icon: 'gym',     rate: 0.5,  kind: 'strength',  outdoor: false },
    hybrid:     { label: 'Hybrid racing',      icon: 'hybrid',  rate: 0.9,  kind: 'strength',  outdoor: false },
    concert:    { label: 'Concert / festival', icon: 'music',   rate: 0.25, kind: 'lifestyle', outdoor: true },
    dayout:     { label: 'Day out in the city', icon: 'sun',    rate: 0.2,  kind: 'lifestyle', outdoor: true }
  };

  var RULES = {
    heatPerDeg: 0.06, heatCap: 1.5, coolFloor: 0.85, baseWbgt: 26,
    indoorWbgt: 24,                       // air-conditioned / sheltered hall
    sweat: { light: 0.8, average: 1, heavy: 1.25 },
    preMlPerKg: [5, 7],                   // 2–4 h before
    duringShare: 0.7, duringCapPerH: 800, // replace ~70% of losses while moving, ≤800 ml/h
    afterFactor: [1.25, 1.5],             // of the remaining deficit, over 2–4 h
    activeMinMins: 45,                    // isotonic during the session from 45 min (or in heat)
    proAfterMins: 90,                     // endurance sessions this long add PRO for recovery
    wbgtOffset: 3,                        // forecast-estimate calibration vs NEA readings
    tabletMaxPerDay: 2, tabletMl: 200,    // per pack: 1 tablet in 200 ml, 1–2 a day
    sachetMl: 230,                        // ACTIVE powder: 15 g sachet in 230 ml
    heat: [{ max: 31, key: 'Low' }, { max: 33, key: 'Moderate' }, { max: 99, key: 'High' }]  // NEA bands
  };

  var ICONS = {
    run: '<path d="M13 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7 21l3-6 3 2v5M10 15l1-5 4 3 3-1M8 9l3-2 3 1"/>',
    ball: '<circle cx="12" cy="12" r="9"/><path d="M12 7l4 3-1.5 4.5h-5L8 10z"/>',
    hoop: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3v18M5.6 5.6c3 3 3 9.8 0 12.8M18.4 5.6c-3 3-3 9.8 0 12.8"/>',
    shuttle: '<path d="M8 15l-4 5M8 15c0-5 2-9 8-12 1 5-1 10-5 12zM11 12l4-4"/>',
    tennis: '<circle cx="9" cy="9" r="6"/><path d="M13.5 13.5L20 20M5 6c2 1 5 4 6 7"/>',
    bike: '<circle cx="6" cy="16" r="4"/><circle cx="18" cy="16" r="4"/><path d="M6 16l4-7h5l3 7M10 9l2 7h-6M14 6h2"/>',
    tri: '<path d="M3 18c2-2 4-2 6 0s4 2 6 0 4-2 6 0M12 5l4 7H8z"/>',
    gym: '<path d="M4 9v6M7 7v10M17 7v10M20 9v6M7 12h10"/>',
    hybrid: '<path d="M13 3L5 14h6l-1 7 8-11h-6z"/>',
    music: '<path d="M9 18V5l11-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>'
  };
  function icon(k) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[k] || '') + '</svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function r50(n) { return Math.max(0, Math.round(n / 50) * 50); }
  function band(w) { for (var i = 0; i < RULES.heat.length; i++) if (w < RULES.heat[i].max) return RULES.heat[i].key; return 'High'; }

  // Approximate WBGT from air temp + RH (Australian BoM approximation), offset down to sit
  // closer to NEA's measured Singapore readings (the raw formula runs ~3° hot in the tropics)
  function approxWbgt(t, rh) {
    var e = rh / 100 * 6.105 * Math.exp(17.27 * t / (237.7 + t));
    return 0.567 * t + 0.393 * e + 3.94 - RULES.wbgtOffset;
  }

  /* ---------- data.gov.sg with a short session cache (unauthenticated calls are rate-limited) ---------- */
  function getJSON(name) {
    var key = 'sp_hyd_' + name;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < CACHE_MIN * 60000) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch(API + name).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (j) {
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: j })); } catch (e) {}
      return j;
    });
  }

  /* ====================================================================== */
  function Planner(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-hyd-config]').textContent);
    this.sku = this.cfg.sku || {};
    var rem = {};
    try { rem = JSON.parse(localStorage.getItem('sp_hyd_prefs') || '{}'); } catch (e) {}
    this.s = {
      act: rem.act && ACT[rem.act] ? rem.act : 'run',
      mins: rem.mins || 60,
      weight: rem.weight || 65,
      sweat: rem.sweat || 'average',
      when: 'now',
      where: 'sg',
      station: rem.station || this.cfg.station || 'avg',
      climate: 'hot',
      indoor: null
    };
    this.wx = null;       // live conditions
    this.fc = null;       // 24h forecast
    this.athlete = -1;
    this.build();
    this.loadWeather();
  }

  Planner.prototype.$ = function (s) { return this.root.querySelector(s); };

  Planner.prototype.build = function () {
    var self = this, s = this.s;
    // activity chips
    var grid = this.$('.hyd-acts');
    grid.innerHTML = Object.keys(ACT).map(function (k) {
      return '<button type="button" class="hyd-act" data-act="' + k + '">' + icon(ACT[k].icon) + '<span>' + ACT[k].label + '</span></button>';
    }).join('');
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.hyd-act'); if (!b) return;
      s.act = b.getAttribute('data-act'); s.indoor = null; self.athlete = -1; self.render();
    });
    // athletes
    this.root.querySelectorAll('[data-ath]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = self.cfg.athletes[+b.getAttribute('data-ath')]; if (!a) return;
        if (ACT[a.act]) s.act = a.act;
        if (a.mins) s.mins = a.mins;
        s.where = a.abroad ? 'abroad' : 'sg';
        var m = self.$('[name="mins"]'); if (m) m.value = s.mins;
        s.indoor = null; self.athlete = +b.getAttribute('data-ath');
        self.render();
        var res = self.$('.hyd-result'); if (res && res.scrollIntoView && window.innerWidth < 900) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    // inputs
    var mins = this.$('[name="mins"]'), wt = this.$('[name="weight"]');
    mins.value = s.mins; wt.value = s.weight;
    mins.addEventListener('input', function () { s.mins = +mins.value; self.render(); });
    wt.addEventListener('input', function () { s.weight = +wt.value; self.render(); });
    this.root.querySelectorAll('[data-seg]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-v]'); if (!b) return;
        var k = g.getAttribute('data-seg'), v = b.getAttribute('data-v');
        s[k] = k === 'indoor' ? v === '1' : v;
        self.render();
      });
    });
    var st = this.$('[name="station"]');
    st.addEventListener('change', function () { s.station = st.value; self.pickedStation = true; self.render(); });
    var loc = this.$('[data-hyd-locate]');
    if (loc && navigator.geolocation) loc.addEventListener('click', function () {
      loc.disabled = true;
      navigator.geolocation.getCurrentPosition(function (p) {
        loc.disabled = false; self.nearest(p.coords.latitude, p.coords.longitude);
      }, function () { loc.disabled = false; }, { timeout: 8000, maximumAge: 600000 });
    }); else if (loc) loc.hidden = true;
    // phones: sticky pill while the inputs are on screen but the plan isn't
    var peek = this.$('.hyd-peek'), inputs = this.$('.hyd-inputs'), result = this.$('.hyd-result');
    if (peek && 'IntersectionObserver' in window) {
      var vis = { i: false, r: false };
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { vis[e.target === inputs ? 'i' : 'r'] = e.isIntersecting; });
        self.root.classList.toggle('hyd-peek-on', vis.i && !vis.r);
      }, { threshold: 0.05, rootMargin: '0px 0px -220px 0px' });
      io.observe(inputs); io.observe(result);
      peek.addEventListener('click', function () { result.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }
    this.render();
  };

  Planner.prototype.loadWeather = function () {
    var self = this;
    getJSON('weather?api=wbgt').then(function (j) {
      var rec = j.data.records[0], rd = rec.item.readings;
      self.wx = { time: rec.datetime, stations: rd.map(function (r) {
        return { id: r.station.id, name: r.station.townCenter || r.station.name, lat: +r.location.latitude, lng: +r.location.longitude, wbgt: +r.wbgt, heat: r.heatStress };
      }).sort(function (a, b) { return a.name.localeCompare(b.name); }) };
      // islandwide average + hottest spot, so the tool works anywhere in Singapore
      var st = self.wx.stations, avg = st.reduce(function (t, x) { return t + x.wbgt; }, 0) / st.length;
      var hot = st.reduce(function (m, x) { return x.wbgt > m.wbgt ? x : m; }, st[0]);
      self.wx.hottest = hot;
      st.unshift({ id: 'avg', name: 'Singapore — islandwide average', wbgt: Math.round(avg * 10) / 10, heat: band(avg), avg: true, n: st.length });
      var sel = self.$('[name="station"]');
      sel.innerHTML = '<option value="avg">Singapore — islandwide average</option><optgroup label="Nearest NEA station">' +
        st.slice(1).map(function (x) { return '<option value="' + x.id + '">' + esc(x.name) + '</option>'; }).join('') + '</optgroup>';
      if (!st.some(function (x) { return x.id === self.s.station; })) self.s.station = 'avg';
      sel.value = self.s.station;
      self.render();
      // if the reader already allowed location for this site, jump straight to their nearest station
      try {
        if (navigator.permissions && navigator.geolocation && !self.pickedStation) navigator.permissions.query({ name: 'geolocation' }).then(function (ps) {
          if (ps.state === 'granted') navigator.geolocation.getCurrentPosition(function (p) { self.nearest(p.coords.latitude, p.coords.longitude); }, function () {}, { maximumAge: 600000, timeout: 8000 });
        });
      } catch (e) {}
    }).catch(function () { self.wxFail = true; self.render(); });
    getJSON('twenty-four-hr-forecast').then(function (j) {
      var g = j.data.records[0].general;
      self.fc = { tHi: g.temperature.high, tLo: g.temperature.low, rhHi: g.relativeHumidity.high, rhLo: g.relativeHumidity.low, text: g.forecast.text };
      self.render();
    }).catch(function () {});
  };

  Planner.prototype.nearest = function (lat, lng) {
    if (!this.wx) return;
    var best = null, bd = 1e9;
    this.wx.stations.forEach(function (x) { var d = Math.hypot(x.lat - lat, (x.lng - lng) * Math.cos(lat * Math.PI / 180)); if (d < bd) { bd = d; best = x; } });
    if (best) { this.s.station = best.id; this.$('[name="station"]').value = best.id; this.render(); }
  };

  /* Conditions for the chosen time/place → { wbgt, label, source } */
  Planner.prototype.conditions = function () {
    var s = this.s, a = ACT[s.act], indoor = s.indoor == null ? !a.outdoor : s.indoor;
    if (s.where === 'abroad') {
      var cl = { hot: 31, warm: 27, cool: 20 }[s.climate];
      return { wbgt: indoor ? Math.min(cl, RULES.indoorWbgt) : cl, src: 'Overseas · ' + { hot: 'hot & humid', warm: 'warm', cool: 'cool' }[s.climate], indoor: indoor, est: true };
    }
    if (indoor) return { wbgt: RULES.indoorWbgt, src: 'Indoors (air-con / sheltered hall)', indoor: true };
    var stn = this.wx && this.wx.stations.filter(function (x) { return x.id === s.station; })[0];
    if (s.when === 'now' && stn) return { wbgt: stn.wbgt, heat: stn.heat, live: true, time: this.wx.time,
      src: stn.avg ? 'Live · average of ' + stn.n + ' NEA stations' + (this.wx.hottest ? ' (hottest: ' + this.wx.hottest.name + ' ' + this.wx.hottest.wbgt.toFixed(1) + '°)' : '') : 'Live at ' + stn.name };
    if (this.fc) {
      // later today / tomorrow: shape the forecast range by hour-of-day (peak ~2pm)
      var hr = { morning: 7, midday: 13, evening: 19 }[s.when] || new Date().getHours();
      var k = Math.max(0, Math.cos((hr - 14) / 24 * Math.PI * 2));   // 1 at 2pm, 0 overnight
      var t = this.fc.tLo + (this.fc.tHi - this.fc.tLo) * k;
      var rh = this.fc.rhHi - (this.fc.rhHi - this.fc.rhLo) * k;
      return { wbgt: Math.round(approxWbgt(t, rh) * 10) / 10, src: 'Forecast estimate · ' + Math.round(t) + '°C, ' + Math.round(rh) + '% RH', est: true };
    }
    return { wbgt: 29, src: this.wxFail ? 'Live data unavailable — using a typical Singapore day' : 'Loading live conditions…', est: true };
  };

  Planner.prototype.plan = function () {
    var s = this.s, a = ACT[s.act], R = RULES, c = this.conditions(), hrs = s.mins / 60;
    var heatF = c.wbgt >= R.baseWbgt ? Math.min(R.heatCap, 1 + (c.wbgt - R.baseWbgt) * R.heatPerDeg) : Math.max(R.coolFloor, 1 + (c.wbgt - R.baseWbgt) * 0.04);
    var wf = Math.max(0.6, Math.min(1.5, s.weight / 70));
    var rate = a.rate * heatF * wf * R.sweat[s.sweat] * 1000;      // ml/h
    var loss = rate * hrs;
    var during = Math.min(rate * R.duringShare, R.duringCapPerH) * hrs;
    var after = Math.max(0, loss - during);
    var pre = [s.weight * R.preMlPerKg[0], s.weight * R.preMlPerKg[1]];
    var hot = c.wbgt >= 31, abroad = s.where === 'abroad';
    var steps = [], skus = {};
    function use(k) { skus[k] = 1; return k; }

    if (a.kind === 'lifestyle') {
      var perH = r50(Math.max(150, rate));
      steps.push({ t: 'Before you head out', ml: '250–500 ml', sku: use(abroad ? 'tablet' : 'zero'),
        how: abroad ? 'Dissolve 1 tablet in ' + R.tabletMl + ' ml of water.' : 'Start hydrated — a chilled 100PLUS Zero Sugar on the way.' });
      steps.push({ t: 'While you\'re out', ml: '~' + perH + ' ml / hour', sku: use('zero'),
        how: 'Sip regularly rather than all at once' + (s.act === 'concert' ? ' — crowds and dancing add up fast.' : '.') + (hot ? ' It\'s a hot one: seek shade between sets.' : '') });
      if (hot || s.mins >= 180 || abroad) steps.push({ t: 'Top up electrolytes', ml: '1 tablet in ' + R.tabletMl + ' ml', sku: use('tablet'),
        how: 'For long, hot days. Max ' + R.tabletMaxPerDay + ' tablets a day.' });
      else steps.push({ t: 'After', ml: r50(Math.max(250, loss * 0.5)) + ' ml', sku: use('zero'), how: 'Rehydrate on the way home.' });
    } else {
      var duringSku = abroad ? 'powder' : (s.mins >= R.activeMinMins || hot ? 'active' : 'water');
      steps.push({ t: '2–4 hours before', ml: r50(pre[0]) + '–' + r50(pre[1]) + ' ml', sku: use(abroad ? 'tablet' : 'active'),
        how: abroad ? 'Dissolve 1 tablet in ' + R.tabletMl + ' ml — handy in hotel rooms and on flights.' : 'Top up with 100PLUS Active so you start fully hydrated.' });
      var every = Math.max(50, r50(during / Math.max(1, s.mins / 15)));
      steps.push({ t: 'During · ' + s.mins + ' min', ml: r50(during) + ' ml total', sku: use(duringSku),
        how: (duringSku === 'water' ? 'Short session — water is fine; switch to 100PLUS Active if it runs past ' + R.activeMinMins + ' min.' :
          duringSku === 'powder' ? 'Mix 1 sachet into ' + R.sachetMl + ' ml of water per bottle — about ' + Math.max(1, Math.round(during / R.sachetMl)) + ' sachet' + (Math.round(during / R.sachetMl) > 1 ? 's' : '') + '.' :
          'Carbs + electrolytes for the effort.') + ' Aim for ~' + every + ' ml every 15 min.' });
      var wantPro = !abroad && (a.kind === 'strength' || (a.kind === 'endurance' && s.mins >= 60) || s.mins >= R.proAfterMins);
      steps.push({ t: 'After · within 2–4 h', ml: r50(after * R.afterFactor[0]) + '–' + r50(after * R.afterFactor[1]) + ' ml', sku: use(abroad ? 'tablet' : 'active'),
        how: 'Replace what you lost — sip, don\'t chug.' + (abroad ? ' Max ' + R.tabletMaxPerDay + ' tablets a day.' : '') });
      if (wantPro) steps.push({ t: 'Recover · within 30–60 min', ml: '1 bottle', sku: use('pro'),
        how: '100PLUS PRO High Protein — 10 g protein + 2 g BCAA for muscle recovery.' });
    }
    return { c: c, band: band(c.wbgt), loss: loss, rate: rate, steps: steps, skus: Object.keys(skus) };
  };

  Planner.prototype.render = function () {
    var self = this, s = this.s, a = ACT[s.act], p = this.plan(), sku = this.sku;
    try { localStorage.setItem('sp_hyd_prefs', JSON.stringify({ act: s.act, mins: s.mins, weight: s.weight, sweat: s.sweat, station: s.station })); } catch (e) {}

    this.root.querySelectorAll('.hyd-act').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-act') === s.act); });
    this.root.querySelectorAll('[data-ath]').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-ath') === self.athlete); });
    this.root.querySelectorAll('[data-seg]').forEach(function (g) {
      var k = g.getAttribute('data-seg'), cur = k === 'indoor' ? ((s.indoor == null ? !a.outdoor : s.indoor) ? '1' : '0') : s[k];
      g.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-v') === cur); b.setAttribute('aria-pressed', b.getAttribute('data-v') === cur); });
    });
    this.$('[data-out="mins"]').textContent = s.mins >= 60 ? (Math.floor(s.mins / 60) + 'h' + (s.mins % 60 ? ' ' + (s.mins % 60) + 'm' : '')) : s.mins + ' min';
    this.$('[data-out="weight"]').textContent = s.weight + ' kg';
    this.root.classList.toggle('hyd-abroad', s.where === 'abroad');
    this.root.classList.toggle('hyd-lifestyle', a.kind === 'lifestyle');

    // conditions card
    var c = p.c, bd = p.band;
    var wx = this.$('.hyd-wx');
    wx.setAttribute('data-band', bd);
    wx.querySelector('.hyd-wx-n').textContent = c.wbgt.toFixed(1) + '°';
    wx.querySelector('.hyd-wx-band').textContent = (c.indoor ? 'Indoors' : bd + ' heat stress');
    wx.querySelector('.hyd-wx-src').textContent = c.src + (c.live && c.time ? ' · ' + new Date(c.time).toLocaleTimeString('en-SG', { hour: 'numeric', minute: '2-digit' }) : '');
    var warn = this.$('.hyd-warn');
    var msg = !c.indoor && bd === 'High' ? (this.cfg.t_high || 'NEA heat stress is HIGH. Consider shortening, slowing down or moving your session indoors or to a cooler time.') :
      !c.indoor && bd === 'Moderate' ? (this.cfg.t_mod || 'Moderate heat stress — take more frequent water breaks and ease off the intensity.') : '';
    warn.textContent = msg; warn.hidden = !msg;

    // headline
    var lossTxt = (p.loss >= 1000 ? (Math.round(p.loss / 100) / 10) + ' L' : r50(p.loss) + ' ml');
    this.$('.hyd-loss-n').textContent = lossTxt;
    var pk = this.$('.hyd-peek-n'); if (pk) pk.textContent = lossTxt + ' sweat';
    this.$('.hyd-loss-sub').textContent = 'estimated sweat loss · ' + a.label.toLowerCase() + ', ' + this.$('[data-out="mins"]').textContent;
    var pct = Math.min(100, p.loss / 2500 * 100);
    this.$('.hyd-gauge i').style.width = pct + '%';

    // steps
    this.$('.hyd-steps').innerHTML = p.steps.map(function (st, i) {
      var k = st.sku, info = sku[k] || {};
      var name = k === 'water' ? 'Water' : (info.name || k);
      return '<li class="hyd-step" style="--d:' + (i * 70) + 'ms">' +
        '<div class="hyd-step-t">' + esc(st.t) + '</div>' +
        '<div class="hyd-step-ml">' + esc(st.ml) + '</div>' +
        '<div class="hyd-step-sku" data-sku="' + k + '">' + (info.img ? '<img src="' + esc(info.img) + '" alt="" loading="lazy">' : '<span class="hyd-dot"></span>') + '<b>' + esc(name) + '</b></div>' +
        '<p>' + esc(st.how) + '</p></li>';
    }).join('');

    // athlete tip
    var tip = this.$('.hyd-tip'), ath = this.cfg.athletes[this.athlete];
    if (ath && ath.tip) {
      tip.hidden = false;
      tip.querySelector('img').src = ath.img || ''; tip.querySelector('img').hidden = !ath.img;
      tip.querySelector('.hyd-tip-q').textContent = '“' + ath.tip + '”';
      tip.querySelector('.hyd-tip-n').textContent = ath.name + (ath.sport ? ' · ' + ath.sport : '');
    } else tip.hidden = true;

    // product rail: highlight what's in today's plan
    this.root.querySelectorAll('[data-prod]').forEach(function (el) { el.classList.toggle('pick', p.skus.indexOf(el.getAttribute('data-prod')) > -1); });

    clearTimeout(this.evT);
    this.evT = setTimeout(function () {
      var ev = { activity: s.act, minutes: s.mins, where: s.where, wbgt: c.wbgt, band: bd, skus: p.skus.join(','), athlete: ath ? ath.name : '' };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sp_hydration_plan', ev); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'sp_hydration_plan' }, ev)); } catch (e) {}
    }, 1200);
  };

  function scan() {
    document.querySelectorAll('[data-sp-hydration]').forEach(function (r) { if (!r.__hyd) { r.__hyd = true; new Planner(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
